<template>
	<div id="activity-type-create">
		<vx-card class="mb-base" title="Form Volume Produk">
			<vue-form-generator
				tag="div"
				:schema="schema"
				:model="model"
				:options="formOptions"
				@model-updated="listen"
			></vue-form-generator>
		</vx-card>
		<div class="vx-col w-full">
			<div class="flex flex-end items-start mb-4">
				<vs-button
					class="mr-4 mb-4"
					color="danger"
					@click="$router.push('/inventory/volume').catch(() => {})"
				>Batal</vs-button>
				<vs-button class="mr-4 mb-4" icon-pack="feather" @click="onConfirm">Simpan</vs-button>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import VueFormGenerator from "vue-form-generator/dist/vfg-core.js";
import ref from "@/api/ref.js";
import form from "@/api/form.js";
import stock from "@/api/stock.js";
import tool from "@/tool/form_tool.js";
import VsCurrency from "@/components/custom-form/vfg-vscurrency";
import VsInput from "@/components/custom-form/vfg-vsinput";
import VsSwitch from "@/components/custom-form/vfg-vsswitch";
import VsSelect from "@/components/custom-form/vfg-vsselect";
import VsNumber from "@/components/custom-form/vfg-vsnumber";
import VsDatePicker from "@/components/custom-form/vfg-vsdatepicker";

Vue.use(VueFormGenerator);
Vue.component("field-vscurrency", VsCurrency);
Vue.component("field-vsinput", VsInput);
Vue.component("field-vsswitch", VsSwitch);
Vue.component("field-vsselect", VsSelect);
Vue.component("field-vsnumber", VsNumber);
Vue.component("field-vsdatepicker", VsDatePicker);

export default {
	data() {
		return {
			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			}
		};
	},
	methods: {
		onConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: `Konfimasi`,
				text: "Anda yakin untuk melanjutkan proses ?",
				acceptText: "Ya",
				cancelText: "Tidak",
				accept: this.submitData
			});
		},
		submitData() {
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};

			stock.saveVolume(this.model, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text:
								"Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.$router.push(
							"/inventory/volume"
						);
					} else {
						this.$vs.notify({
							title:
								"Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title:
								"An Error Occured",
							time: 3000,
							text:
								error.response
									.data
									.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
		},

		async firstLoad() {
			const frm = await form.getFormVolume();
			this.schema.fields = frm.data.data[0].fields;
			let idx = this.$route.params.id;
			if (idx) {
				const xmodel = await stock.getVolume(idx);
				this.model = xmodel.data.data[0];
			} else {
				this.model = frm.data.data[0].model;
			}
		
		},
	},
	created() {
		this.firstLoad();
	}
};
</script>

<style lang="scss" scoped>
.bordered {
	border-width: 1px;
	border-radius: 4px;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
	margin: 0;
}
.vx-custom-remove-icon {
	text-align: right;
}
.vs-textarea-primary.focusx {
	border: 1px solid #0056a8 !important;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
}
.vs-checkbox-default {
	transform: translate(0, -70%);
	top: 70%;
}
</style>
